
export const MultiLevelSearch = ({search, data, levels}) => {
    const matcher = TextMatcher(search);
    const match = (r, levelIndex) => {

        const level = levels[levelIndex];

        const matches = level.targets
            .map((t) => ({
                name: t.name,
                match: matcher(t.getText(r)),
            }))
            .filter((t) => t.match)
        ;

        const children = level.getChildren?.(r).map((c) => match(c, levelIndex + 1)).filter(v=>v);
        if (children?.length || matches.length) {
            return {
                key: level.getKey(r),
                matches,
                children,
            };
        }
        return null;
    };
    return data.map((r) => match(r, 0)).filter(v=>v);
};

const TextMatcher = (searchText) => {
    searchText = searchText.toLowerCase();
    return (text) => {
        const from = text.toLowerCase().indexOf(searchText);
        if (from > -1) {
            return {ranges: [{from, to: from + searchText.length}]};
        } else {
            return null;
        }
    };
};
